import { createAction, props } from '@ngrx/store';
import { Organisation, OrganisationUser } from '@graphql/generated';

export const setSelectedOrganisation = createAction('[Organisation] Set Selected Organisation', props<{ selectedOrganisation: Organisation }>());
export const setOrganisationUser = createAction('[Organisation] Set Organisation User', props<{ organisationUser: OrganisationUser }>());
export const loadOrgIdFromLocalStorage = createAction('[Organisation] Load Selected Organisation Id From Local Storage');
export const setOrgIdToLocalStorage = createAction('[Organisation] Load Selected Organisation Id T0 Local Storage', props<{ orgId: string }>());
export const clearOrganisationContext = createAction('[Organisation] Clear Organisation Context');
